namespace Areas.Ucla {
    "use strict";

    const tabItems = Areas.createTabsWithSameController("Ucla", ["Index", "Individual", "SupersededBy", "UcopLink"], "Detail");

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }
 
}
